import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BomTableComparisonComponent } from './bom-table-comparison/bom-table-comparison.component';
import { TreeCardComponent } from './tree-card/tree-card.component';
import { ProjectTreeComparisonComponent } from './project-tree-comparison/project-tree-comparison.component';

@NgModule({
  declarations: [
    BomTableComparisonComponent,
    TreeCardComponent,
    ProjectTreeComparisonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbDropdownModule,
    NgbTooltipModule,
    MatCardModule,
    MatCheckboxModule,
    MatSnackBarModule
  ],
  exports: [
    BomTableComparisonComponent
  ]
})
export class BomTableComparisonModule { }
